export default "__VITE_PUBLIC_ASSET__9b6bac2a__"